import { CardHeader, Skeleton, Typography } from '@mui/material';
import React from 'react';
import type { Article } from 'types';
import { ArticleOptionsIcon } from './ArticleOptions';

const headerStyles = {
	paddingBottom: 0,
	'& div': { overflow: 'hidden' },
	'& .MuiCardHeader-title': { fontSize: '1.6rem', whiteSpace: 'nowrap' },
	'& .MuiCardHeader-content': { minWidth: 0, minHeight: 48, display: 'flex', flexDirection: 'column', justifyContent: 'center' },
};

export function ArticleTileHeader({ record, locale, avatar, subtitle = record?.group }: {
	record?: Article;
	locale: string;
	avatar?: React.ReactNode;
	subtitle?: string;
}) {
	const titleLocale = record?.title[locale] ? locale : record?.title.hi ? 'hi' : 'en';
	return <CardHeader
		sx={headerStyles}
		avatar={avatar}
		action={record ? <ArticleOptionsIcon record={record} /> : null}
		title={record ? <Typography noWrap className={titleLocale === 'hi' ? 'locale-hi' : ''}>
			{record.title[locale] || record.title.hi || record.title.en}
		</Typography> : <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />}
		subheader={record ? <Typography variant="body2" color="textSecondary" noWrap className="locale-en">
			{subtitle}
		</Typography> : <Skeleton animation="wave" height={10} width="40%" />}
	/>;
}
